import { levelHistoryParcel } from '~/parcels/index.js';
import { LitEntity, html } from '../js/utility/lit-entity';
import './parcel-loader';

class LevelHistory extends LitEntity {
  render() {
    const passThroughProperties = {
      href: this.href,
    };

    return html`
      <parcel-loader
        .parcel=${levelHistoryParcel}
        .passThroughProperties=${passThroughProperties}
      ></parcel-loader>
    `;
  }
}

window.customElements.define('level-history', LevelHistory);
